// this config object allows us to use the same config.get syntax, and the same
// etcd keys as other etcd calls in node.
//
// add new keys in server/lib/master_template_data

const config = {

    initialize(store) {
        this.store = store
    },

    get(key, default_value) {
        if (! this.store) throw new Error('config.store has not been initialized yet!')

        // look up the value in the config store
        const value = this.store[key]

        // handle undefined values
        if (typeof value === 'undefined') {
            // if default value is provided, return that instead
            if (typeof default_value !== 'undefined') return default_value
            // throw errors for undefined keys in dev
            if (__DEBUG__) throw new Error(`key not found: '${key}'`)
        }

        return value
    },

}

module.exports = config
